<aside class="sidebar" [class.sidebar--open]="mobileOpen" aria-label="Main navigation">
  <nav class="sidebar__nav">
    <a routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="onNavClick()">
      <i class="fas fa-home"></i>
      <span>Dashboard</span>
    </a>

    <p class="sidebar__section">Analysis</p>
    <a routerLink="/risk" routerLinkActive="active" (click)="onNavClick()">
      <i class="fas fa-chart-bar"></i>
      <span>Greenwashing Risk</span>
    </a>
    <a routerLink="/company-summary" routerLinkActive="active" (click)="onNavClick()">
      <i class="fas fa-chart-line"></i>
      <span>Company Analysis</span>
    </a>
    <a routerLink="/similar-companies" routerLinkActive="active" (click)="onNavClick()">
      <i class="fas fa-link"></i>
      <span>Similar Companies</span>
    </a>
    <a routerLink="/eda" routerLinkActive="active" (click)="onNavClick()">
      <i class="fas fa-chart-pie"></i>
      <span>Data Insights</span>
    </a>
    <a routerLink="/text-analysis" routerLinkActive="active" (click)="onNavClick()">
      <i class="fas fa-file-alt"></i>
      <span>Text Analysis</span>
    </a>
    <a routerLink="/prediction" routerLinkActive="active" (click)="onNavClick()">
      <i class="fas fa-bullseye"></i>
      <span>Prediction</span>
      <i class="fas fa-lock sidebar__lock" aria-hidden="true"></i>
    </a>
    <a routerLink="/stock-prediction-rl" routerLinkActive="active" (click)="onNavClick()">
      <i class="fas fa-robot"></i>
      <span>Stock RL</span>
    </a>
    <!-- <a routerLink="/finance" routerLinkActive="active" (click)="onNavClick()">
      <i class="fas fa-pound-sign"></i>
      <span>Finance</span>
    </a> -->

    <p class="sidebar__section">Info</p>
    <a routerLink="/about" routerLinkActive="active" (click)="onNavClick()">
      <i class="fas fa-info-circle"></i>
      <span>About</span>
    </a>
    <a routerLink="/help" routerLinkActive="active" (click)="onNavClick()">
      <i class="fas fa-question-circle"></i>
      <span>Help</span>
    </a>
  </nav>
</aside>
@if (mobileOpen) {
  <button type="button" class="sidebar-backdrop" aria-label="Close menu" (click)="onNavClick()"></button>
}
